import React from "react";
import withRouter from "../../Components/Common/withRouter";
import logo from "../../assets/images/logo_horizontal.png";

const ParticlesAuth = ({ children }: any) => {
  return (
    <React.Fragment>
      <div className="auth-page-wrapper">
        <div style={{ textAlign: "center" }}>
          <img src={logo} height="100" />
        </div>
        {children}
        <footer className="footer" style={{ marginBottom: 20 }}>
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="text-center">
                  <p className="mb-0 text-muted">
                    &copy; {new Date().getFullYear()}.
                    <i className="mdi mdi-heart text-danger"></i> Grupo AV
                  </p>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ParticlesAuth);
